module.exports = __webpack_public_path__ + "img/ic_phone_logo.82d2b9e1.webp";